let environment = "local";
let config = null

if (environment === "local") {
    config = {
        Backend_url: ""
    }
}

export default config